import { render } from "./nominalValue.vue?vue&type=template&id=2c61ca29"
import script from "./nominalValue.vue?vue&type=script&lang=ts"
export * from "./nominalValue.vue?vue&type=script&lang=ts"
script.render = render

export default script